import React, { Component } from "react";
import Section from "./layouts/Section";
import OurCalendars from "./layouts/calendars/OurCalendars";

class Teams extends Component {
    render() {
        return (
            <Section title={'Calendari'}>
                <OurCalendars />
            </Section>
        );
    }
}

export default Teams;